import React from "react";
import {Button, Checkbox, Form, Icon, Input, message} from "antd";
import {connect} from "react-redux";
import {Link} from "react-router-dom";

import {
  forgotPassword,
  confirmForgotPassword
} from "appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;

class ForgotPassword extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  handleSubmit = (e) => {
    if(e) e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true
        });

        this.props.confirmForgotPassword(values);
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loading && this.props.showMessage &&
    prevProps.showMessage!= this.props.showMessage) {
      this.setState({
        loading: false
      });

      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }

    if (this.state.loading && !prevProps.forgotPasswordRes &&
      this.props.forgotPasswordRes) {
      this.setState({
        loading: false
      });

      message.success('Confirmation code sent to your email');
    }

    if (this.state.loading && !prevProps.confirmForgotPasswordRes &&
      this.props.confirmForgotPasswordRes) {
      message.success('Password reset successfully. Please login with your new password.');

      this.setState({
        loading: false
      });

      this.props.history.push('/social-apps/signIn');
    }

    if (this.state.loading && !prevProps.error && this.props.error) {
      this.setState({
        loading: false
      });

      console.log('this.props.error', this.props.error);

      const type = this.props.error.data.type;

      if (type == 'NotAuthorizedException') {
        message.error('Invalid credentails');
      } else if (type == 'InvalidPasswordException') {
        message.error('Invalid password format. Password must be at least 8 characters.');
      } else if (type == 'InvalidParameterException') {
        message.error('Invalid password format. Password must be at least 8 characters.');
      } else if (type == 'AccountNotApproved') {
        message.error("Account hasn't been approved by the administrator. Please come back again later");
      } else if (type == 'EmailNotFound') {
        message.error("There's no approved account associated with this email");
      } else if (type == 'CodeMismatchException') {
        message.error("Code is invalid or already expired");
      } else if (type == 'ExpiredCodeException') {
        message.error("This confirmation code has been expired. Please request for a new code.");
      } else {
        message.error(type);
      }
    }
  }

  onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
      // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        this.handleSubmit();
      }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;

    return (
      <div className="gx-app-login-wrap gx-bg-margo-gradient">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
              </div>
              <div className="gx-app-logo-wid">
                <h1>Forgot Password</h1>
              </div>
              <div className="gx-app-logo">
                <img alt="example" src={require("assets/images/logo.png")}/>
              </div>
            </div>
            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0">

                <FormItem>
                  {getFieldDecorator('email', {
                    initialValue: "",
                    rules: [{
                      required: true, type: 'email', message: 'The input is not valid E-mail!',
                    }],
                  })(
                    <Input onKeyDown={this.onKeyDown} placeholder="Email"/>
                  )}
                  <Button type="primary" className="gx-mb-0" disabled={this.props.form.getFieldValue('email') == ''}
                  onClick={(e) => {
                    this.setState({
                      loading: true
                    });

                    this.props.forgotPassword(this.props.form.getFieldValue('email'));
                  }}>
                    Get Confirmation Code
                  </Button>
                </FormItem>
                <FormItem>
                  {getFieldDecorator('confirmationCode', {
                    initialValue: "",
                    rules: [{
                      required: true, message: 'Confirmation code is required',
                    }],
                  })(
                    <Input onKeyDown={this.onKeyDown} placeholder="Confirmation Code"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    initialValue: "",
                    rules: [{required: true, message: 'Please input your Password!'}],
                  })(
                    <Input onKeyDown={this.onKeyDown} type="password" placeholder="Password"/>
                  )}
                </FormItem>
                <FormItem>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    Reset Password
                  </Button>
                  <span><IntlMessages id="app.userAuth.or"/></span> <Link to="/signin">Back To Sign In</Link>
                </FormItem>
              </Form>
            </div>

            {this.state.loading ?
              <div className="gx-loader-view">
                <CircularProgress/>
              </div> : null}
          </div>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(ForgotPassword);

const mapStateToProps = ({auth, common}) => {
  const {loader, alertMessage, forgotPasswordRes, confirmForgotPasswordRes} = auth;
  const {error} = common;
  return {loader, alertMessage, forgotPasswordRes, confirmForgotPasswordRes, error}
};

export default connect(mapStateToProps, {
  forgotPassword,
  confirmForgotPassword
})(WrappedNormalLoginForm);
